import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Documents\DocumentController::store
* @see app/Http/Controllers/Admin/Documents/DocumentController.php:168
* @route '/customers/{customer}/documents'
*/
export const store = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/customers/{customer}/documents',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Documents\DocumentController::store
* @see app/Http/Controllers/Admin/Documents/DocumentController.php:168
* @route '/customers/{customer}/documents'
*/
store.url = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { customer: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { customer: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            customer: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        customer: typeof args.customer === 'object'
        ? args.customer.id
        : args.customer,
    }

    return store.definition.url
            .replace('{customer}', parsedArgs.customer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Documents\DocumentController::store
* @see app/Http/Controllers/Admin/Documents/DocumentController.php:168
* @route '/customers/{customer}/documents'
*/
store.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Documents\DocumentController::store
* @see app/Http/Controllers/Admin/Documents/DocumentController.php:168
* @route '/customers/{customer}/documents'
*/
const storeForm = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Documents\DocumentController::store
* @see app/Http/Controllers/Admin/Documents/DocumentController.php:168
* @route '/customers/{customer}/documents'
*/
storeForm.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Documents\DocumentController::storeMany
* @see app/Http/Controllers/Admin/Documents/DocumentController.php:211
* @route '/customers/{customer}/documents/batch'
*/
export const storeMany = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: storeMany.url(args, options),
    method: 'post',
})

storeMany.definition = {
    methods: ["post"],
    url: '/customers/{customer}/documents/batch',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Documents\DocumentController::storeMany
* @see app/Http/Controllers/Admin/Documents/DocumentController.php:211
* @route '/customers/{customer}/documents/batch'
*/
storeMany.url = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { customer: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { customer: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            customer: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        customer: typeof args.customer === 'object'
        ? args.customer.id
        : args.customer,
    }

    return storeMany.definition.url
            .replace('{customer}', parsedArgs.customer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Documents\DocumentController::storeMany
* @see app/Http/Controllers/Admin/Documents/DocumentController.php:211
* @route '/customers/{customer}/documents/batch'
*/
storeMany.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: storeMany.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Documents\DocumentController::storeMany
* @see app/Http/Controllers/Admin/Documents/DocumentController.php:211
* @route '/customers/{customer}/documents/batch'
*/
const storeManyForm = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: storeMany.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Documents\DocumentController::storeMany
* @see app/Http/Controllers/Admin/Documents/DocumentController.php:211
* @route '/customers/{customer}/documents/batch'
*/
storeManyForm.post = (args: { customer: string | { id: string } } | [customer: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: storeMany.url(args, options),
    method: 'post',
})

storeMany.form = storeManyForm

const documents = {
    store: Object.assign(store, store),
    storeMany: Object.assign(storeMany, storeMany),
}

export default documents